// @flow
import { combineReducers } from 'redux';

import isLoading from './is-loading/isLoading.reducer';
import transports from './transports/transports.reducer';
import error from './error/error.reducer';
import filters from './filters/filters.reducer';
import filteredTransports from './filtered-transports/filteredTransports.reducer';
import sorters from './sorters/sorters.reducer';

export default combineReducers({
  error,
  isLoading,
  transports,
  filters,
  sorters,
  filteredTransports,
});
